import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function StatCard({
  label,
  value,
  icon: Icon,
  trend,
  trendLabel,
  loading,
  accent = "primary",
}) {
  const accentBg = {
    primary: "bg-primary/10 text-primary",
    amber: "bg-accent/15 text-accent-foreground",
    emerald: "bg-success/15 text-success",
    sky: "bg-chart-4/15 text-chart-4",
    violet: "bg-chart-5/15 text-chart-5",
  }[accent];

  const TrendIcon = trend === undefined ? null : trend > 0 ? TrendingUp : trend < 0 ? TrendingDown : Minus;
  const trendColor = trend === undefined ? "" : trend > 0 ? "text-success" : trend < 0 ? "text-destructive" : "text-muted-foreground";

  return (
    <Card data-testid="stat-card" className="relative overflow-hidden border-border/70 shadow-sm hover:shadow-md transition-shadow">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium">{label}</p>
            {loading ? (
              <div className="h-9 w-24 mt-2 rounded-md shimmer" />
            ) : (
              <p className="mt-1.5 text-3xl font-semibold tracking-tight">{value}</p>
            )}
            {!loading && trend !== undefined && (
              <div className={cn("mt-2 flex items-center gap-1 text-xs font-medium", trendColor)}>
                {TrendIcon && <TrendIcon className="size-3.5" />}
                <span>
                  {trend > 0 ? "+" : ""}
                  {trend}%
                </span>
                {trendLabel && <span className="text-muted-foreground font-normal">vs. {trendLabel}</span>}
              </div>
            )}
          </div>
          {Icon && (
            <div className={cn("size-10 rounded-xl flex items-center justify-center", accentBg)}>
              <Icon className="size-5" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
